export default __webpack_public_path__ + "static/media/frog_R1_C7.8e2493e1.png";